import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { get } from 'lodash';
import LoaderButton from '../LoaderButton/LoaderButton';
import { styles } from './formStyles';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const BuyNowForm = ({ buyNowContract, setModal, t, }) => {
  const classes = useStyles();
  return (
    <div>
      <LoaderButton
        label={`${t('buy_now')} ${get(buyNowContract, 'price')} €`}
        dataTestId="submitBuyNowForm"
        className={classes.buyNowButton}
        onClick={
          () => {
            setModal({
              componentName: 'BuyNowModal',
              customContentClass: classes.modalStyles,
            });
          }
        }
      />
      <div className={classes.expiresAt}>
        {t('buy_now_expires_date')}
        {get(buyNowContract, 'expires_at_date')}
      </div>
      <div className={classes.sendOffer}>{t('or_send_offer')}</div>
    </div>
  );
};
BuyNowForm.propTypes = {
  setModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  buyNowContract: PropTypes.shape({
    expires_at_date: PropTypes.string,
  }).isRequired,
};

const useStyles = createUseStyles({
  buyNowButton: {
    width: '100%',
    backgroundColor: styles.colors.green,
  },
  expiresAt: {
    borderBottom: `1px solid ${styles.colors.grayBorder}`,
    fontSize: '14px',
    color: styles.colors.darkGray,
    padding: '20px 0px',
    textAlign: 'center',
  },
  sendOffer: {
    backgroundColor: '#f4f3f7',
    color: styles.colors.darkGray,
    fontSize: '14px',
    width: 'fit-content',
    margin: 'auto',
    marginTop: '-11px',
    padding: '0px 12px',
  },
  modalStyles: {
    width: '100% !important',
    maxWidth: '600px !important',
  },
});

export default withScopedTranslations('dealers_offers')(BuyNowForm);
